export default "__VITE_ASSET__CEt7fqtI__"